<template>
    <div class="edit-model-modal">
        <ns-loader
            :toLoad="extraDataToFetch"
            @dataFetched="onDataFetched"
        >
            <div slot="content">
                <el-form

                    ref="form"
                    :model="form"
                    :rules="rules"
                    label-position="left"
                    label-width="200px"
                >
                    <el-form-item
                        v-for="(value, key) in formFieldsToDisplay"
                        :key="key"
                        :label="fieldKeyToVerbose(key)"
                    >
                        <template v-if="hasKeyOverriden(key)">
                            <!-- le '_uid' est ajouté sur le v-model du select en mode édition car on ne peut setter les fields foreignkey directement, il faut passer par le champs qui à le suffix '_uid' -->
                            <el-select
                                v-model="form[`${key}_uid`]"
                                :multiple="overrideDisplay[key].isMultiple"
                                :disabled="readOnly"
                                @change="foreignkeyUpdated(key, $event)"
                            >
                                <el-option
                                    v-for="item in extraDataFetched[key]"
                                    :key="item.uid"
                                    :label="item[overrideDisplay[key].fieldToDisplay]"
                                    :value="item.uid"
                                >
                                </el-option>
                            </el-select>
                        </template>
                        <json-editor
                            v-else-if="isJsonField(key)"
                            :json="JSON.parse(value)"
                            @json-updated="onJsonValueUpdated(key, $event)"
                        ></json-editor>
                        <template v-else >
                            <template v-if="inputType(key) === null||inputType(key) === 'string'">
                                <el-input
                                    v-model="form[key]"
                                    :disabled="readOnly"
                                ></el-input>
                            </template>
                            <template v-else-if="inputType(key) === 'boolean'">
                                <el-switch
                                    v-model="form[key]"
                                    :disabled="readOnly"
                                    :active-text="editOptions.nonStringInput[key].activeText || 'On'"
                                    :inactive-text="editOptions.nonStringInput[key].inactiveText || 'Off'">
                                </el-switch>
                            </template>
                            <template v-else-if="inputType(key) === 'array'">
                                <el-select
                                    v-model="form[key]"
                                    :disabled="readOnly"
                                    :multiple="editOptions.nonStringInput[key].multiple"
                                >
                                    <el-option
                                        v-for="item in editOptions.nonStringInput[key].data"
                                        :key="item"
                                        :label="item"
                                        :value="item"
                                    >
                                    </el-option>
                                </el-select>
                            </template>
                        </template>
                    </el-form-item>
                </el-form>
            </div>
        </ns-loader>
    </div>
</template>
<script>
import NsLoader from '../ns-vue-loader.vue';
import { JSONView } from 'vue-json-component';
import JsonEditor from './json-editor.vue';

export default {
    components: {
        NsLoader,
        'json-view': JSONView,
        JsonEditor,
    },
    props: {
        attrs: {
            type: Object,
            required: true,
        },
        editOptions: {
            type: Object,
            default () {
                return {};
            },
        },
        overrideDisplay: {
            type: Object,
            default () {
                return {};
            },
        },
        store: {
            type: Object,
            default () {
                return {};
            },
        },
        getVerbose: {
            type: Function,
            required: true
        },
        readOnly: {
            type: Boolean,
            default: false,
        }
        // exemple de overrideDisplay
        // {
        //     fieldName: {
        //         fieldToDisplay: String required 'field name to display',
        //         isMultiple: Bool not required 'if values is a many to many field',
        //         toLoad: Object not required 'take same keys than ns-vue-loader to-load object'
        //     }
        // }
    },
    data() {
        return {
            editMode: false,
            form: {},
            rules: {},
            hiddenKeys: [
                'uid',
                'modification_date',
                'creation_date',
                'url',
                'verbose_name',
                'can_view_users',
                'can_view_groups',
                'can_admin_users',
                'created_by',
                'can_admin_groups',
            ],
            extraDataFetched: {},
        };
    },
    computed: {
        mergedHiddenKeys() {
            let array = JSON.parse(JSON.stringify(this.hiddenKeys));
            if(this.editOptions.extraHiddenKeys !== undefined){
                array.push(...this.editOptions.extraHiddenKeys);
            }
            return array;
        },
        keysInOverrideDisplay() {
            let keys = Object.keys(this.overrideDisplay);
            let keysWithSuffixedUid = [];
            for (let key of keys) {
                keysWithSuffixedUid.push(`${key}_uid`);
            }
            return keys.concat(keysWithSuffixedUid);
        },
        // get data to fetch specified in overrideDisplay
        extraDataToFetch() {
            let toFetch = [];
            for (let key in this.overrideDisplay) {
                if (this.overrideDisplay[key].toLoad) {
                    toFetch.push(this.overrideDisplay[key].toLoad);
                }
            }
            return toFetch;
        },
        // repertorie tous les fields de type foreignkey
        foreignKeyFields() {
            let array = [];
            for (let field in this.attrs) {
                for (let fieldAgain in this.attrs) {
                    if (field === fieldAgain) continue;
                    if (`${field}_uid` === fieldAgain) {
                        array.push(field);
                        array.push(fieldAgain);
                    }
                }
            }
            return array;
        },
        // display only field who is not in mergedHiddenKeys and includes _uid (uid of foreign keys)
        formFieldsToDisplay() {
            let form = {};
            for (let key in this.form) {
                if (!this.mergedHiddenKeys.find((hiddenKeys) => hiddenKeys === key)) {
                    if (
                        key.includes('_uid') ||
                        (this.editOptions.keysToHide !== undefined && this.editOptions.keysToHide.includes(key))
                    ) {
                        continue;
                    }
                    form[key] = this.form[key];
                }
            }
            return form;
        },

        nonStringFormFieldsDeclared (){
            let warnTypeNotDeclared = [];
            let uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/;
            for (let key in this.formFieldsToDisplay) {
                let fieldType = typeof this.formFieldsToDisplay[key];
                if(
                    fieldType !== 'string' &&  (
                        this.editOptions.nonStringInput === undefined ||
                        this.editOptions.nonStringInput[key] === undefined
                    )
                ){
                    warnTypeNotDeclared.push(`'${key}' is not a string and not declared in the props 'editOptions'. The value will not be display correctly in the detail modal on row click.`);
                }else if(
                    this.formFieldsToDisplay[key].match(uuidRegex) && (
                        this.editOptions.nonStringInput === undefined ||
                        this.editOptions.nonStringInput[key] === undefined
                    )
                ){
                    warnTypeNotDeclared.push(`'${key}' is not a string and not declared in the props 'editOptions'. The value will not be display correctly in the detail modal on row click.`);
                }

            }
            if(warnTypeNotDeclared.length){
                warnTypeNotDeclared.unshift('NS-PAGINATE WARN FOR PROPS DECLARATION');
                warnTypeNotDeclared.push('For more information go to https://git.netsach.info/concrete/fundation-app-vuejs/-/wikis/component-ns-paginate');
            }
            return warnTypeNotDeclared;
        },
    },

    watch: {
    },

    updated (){

    },
    mounted() {
        for (let key in this.attrs) {
            let val = this.attrs[key];
            // différencie un field de type json d'un field de type fk
            if (
                typeof val === 'object' &&
                !(val instanceof Array) &&
                !this.isFieldIsAForeignKey(key) &&
                val !== null
            ) {
                val = JSON.stringify(val);
            }
            this.$set(this.form, key, val);
        }
        if(this.nonStringFormFieldsDeclared.length){
            console.warn(this.nonStringFormFieldsDeclared.join('\n\n'));
        }
    },
    created() {
        this.$store = this.store;
    },
    methods: {
        displayKey (key){
            if(this.editOptions.keysToHide !== undefined && this.editOptions.keysToHide.includes(key)){
                return false;
            }
            return true;
        },
        inputType (key){
            if(this.editOptions.nonStringInput !== undefined && this.editOptions.nonStringInput[key] !== undefined){
                return this.editOptions.nonStringInput[key].type;
            }
            return null;
        },
        hasKeyOverriden(key) {
            return this.keysInOverrideDisplay.includes(key);
        },
        onDataFetched(response) {
            this.extraDataFetched = Object.assign({}, this.extraDataFetched, response);
            this.$set(this, 'extraDataFetched', response);
        },
        isFieldIsAForeignKey(field) {
            return this.foreignKeyFields.find((fkField) => fkField === field);
        },
        isJsonField(field) {
            if (this.form[field] === null) return false;
            try {
                return typeof JSON.parse(this.form[field]) === 'object';
            } catch (e) {
                return false;
            }
        },
        foreignkeyUpdated(field, value) {
            this.$set(this.form, field, value);
        },

        onJsonValueUpdated(key, json){
            this.form[key] = json;
        },
        fieldKeyToVerbose (key){
            if(this.editOptions.hasOwnProperty('verboseKey') && this.editOptions.verboseKey.hasOwnProperty(key)){
                return this.editOptions.verboseKey[key];
            }
            return key;
        },
    },
};

</script>
<style lang="scss">
.vue-tooltip-visible{
    z-index: 2001;
}
.modal-edit {
    min-width: 40vw;
    width: auto;
    // max-width: 70vw;
    width: 60vw;
    height: auto;
    .edit-model-modal {
        .edit-button {
            display: flex;
            margin-left: auto;
        }
        .el-form{
            overflow: auto;
            max-height: 70vh;
            margin-bottom: 15px;
        }
        .fk-m2m:not(:last-child) {
            margin-right: 5px;

            &::after {
                content: ",";
            }
        }
        .not-setted{
            color: grey;
            font-style: italic;
        }
        hr{
            margin-top: 5px;
            margin-bottom: 5px;
        }

        .boolean-icon{
            font-size: 20px;
            font-weight: bold;
        }
        .el-icon-circle-close {
            color: #f56c6c;
        }
        .el-icon-circle-check {
            color: #67c23a;;
        }
    }
}

</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/partials/nsPaginate/modal-detail.vue